import { getHostName } from './hostname';
import { whiteSwooshDarkTheme } from './themes';

export const BRAND_NAMES = {
  JORDAN: 'jordan',
  NIKE: 'nike',
  NIKE_JOURNAL: 'nikeJournal',
  NIKESKIMS: 'nikeSkims',
};

export const uatHost = 'uat.nike.com';

export const PAGE_TYPES = {
  ARTICLE: 'article',
  PAGE: 'page',
  SIZE_CHART: 'size_chart',
};

/**
 * Map of the supported flags
 */
export const FEATURE_FLAGS = {
  DISABLE_ANALYTICS_CLIENT: 'x-disable-analytics-client',
  DISABLE_APPS_FLYER: 'x-disable-appsflyer',
  DISABLE_GLOBAL_NAV: 'x-disable-global-nav',
  DISABLE_MC: 'x-disable-mc',
  DISABLE_SHOP_CART: 'x-disable-shop-cart',
  DISABLE_UI_EXPERIMENTS: 'x-disable-ui-experiments',
  ENABLE_CONSOLE_LOGGING: 'x-enable-console-logging',
  WITH_MOCKS: 'clp-with-mocks',
};
/**
 * Map of the supported utility flags
 */
export const UTILITY_FLAGS = {
  NIKE_ENV: 'nikeEnv',
  PREVIEW_VARIANT_ID: 'variationId',
  TS: 'ts',
};

export const NIKE_BASE_URL = `https://${getHostName()}`;
export const API_BASE_URL = `https://${process.env.NEXT_PUBLIC_API_HOST_NAME}`;

export const APPS_SMART_BANNER_ID = '_td_smartbanner_js'; // smart-banner ID should be a fixed value, never change it

export const CHANNEL_IDS = {
  BANNER: '8fac54d0-ed4f-4cf5-b829-e04d3d6008f8',
  DEFAULT: 'd9a5bc42-4b9c-4976-858a-f159cf99c647',
  SNKRS: '010794e5-35fe-4e32-aaff-cd2c74f89d61',
};

// Interest IDs
export const INTEREST_ID__SKIMS = '9bca7d41-d1c3-43bd-b7a3-8eed3edd8554';
export const interestParam = 'interests';
export const interestParamValue = 'addSkimsInterest';

export const COLLECTIONS = {
  howTo: {
    collectionId: 'fe94947a-f05b-4a2b-a438-e4ddf24477eb',
  },
  nikeJournal: {
    collectionId: 'a169eb4b-d643-419b-aa03-988d18535d25',
    taxonomyTag: '36d163a1-fa45-45c0-bfbb-3d174015d851',
  },
  sizeCharts: {
    collectionId: '32c0681c-e627-4f6d-9390-ce83e7fba02c',
  },
};

export const segmentProdKey = '2iv4Qa7rFEipAs4iE850BkBpTYQvlAFZ';
export const segmentTestKey = 'POwa4r8vBBSw7xdQZ0dqGlNuyaT7Y7pZ';

// (\/[a-z]{2})? - part for checking of location and lang
export const PREVIEW_REGEXP = /^(\/[a-z]{2})?(\/[a-z]{2})?(\/clp)?\/thread/i;

export const clientIds = {
  homepage: 'nike:dotcom.browse.homepage:client:1.0',
  landingpage: 'nike:dotcom.browse.landingpage:client:1.0',
};

export const BRANDS = {
  [BRAND_NAMES.JORDAN]: {
    collectionId: '4b69f63c5e87c687f251bdea1f82121b32018ae5',
  },
  [BRAND_NAMES.NIKESKIMS]: {
    collectionId: 'f25b66e8-d61d-47cb-b985-9edb075b6f38',
  },
};

// id of node that mounts react app
export const ROOT_ELEMENT_ID = 'ciclp-app';
export const NIKE_SHOP_ELEMENT_ID = 'nike-shop-root';
export const ADOBE_TARGET_COOKIE_NAME = 'at_lp_exp';
export const DEFAULT_OPTIMIZATION_LOCATION_NAME = 'landingpage_layout';
export const ABOVE_THE_FOLD_OPTIMIZATION_LOCATION_NAME =
  'landingpage_abovethefoldLayout';

// Measurement-related constants extracted here from Redux app to enable Bra Size Finder bundle splitting
export const MEASUREMENT_TYPE = 'IMPERIAL/METRIC';
export const MEASUREMENTS_UNITS = {
  IMPERIAL: 'IMPERIAL',
  METRIC: 'METRIC',
};

export const DEFAULT_IMPERIAL_COUNTRIES = ['US', 'GB', 'CA'];

export const SECTIONHEADLINE_ACTION_CLASSNAME = 'sectionheadline-action-btn';

export const DEFAULT_THEME = 'light';
export const DARK_THEME = 'darktheme';
export const DARK_BEIGE_THEME = 'darkBeige';
export const DARK_WHITE_THEME = 'dark';
export const NIKE_SKIMS_THEME = 'nike_skims';
export const ACG_HPTO_THEME = 'acg_HPTO';
export const ACG_LP_THEME = 'acg_LP';
export const GF26_HPTO_THEME = 'gf26_HPTO';
export const GF26_LP_THEME = 'gf26_LP';

export const THEME_BRAND_NAMES = {
  ACG_HPTO: ACG_HPTO_THEME,
  ACG_LP: ACG_LP_THEME,
};

export const APPROVED_THEMES = [
  DEFAULT_THEME,
  NIKE_SKIMS_THEME,
  DARK_WHITE_THEME,
  ACG_HPTO_THEME,
  ACG_LP_THEME,
  GF26_HPTO_THEME,
  GF26_LP_THEME,
];

export const DYNAMIC_THEMES = new Set([
  NIKE_SKIMS_THEME,
  ACG_HPTO_THEME,
  ACG_LP_THEME,
  GF26_HPTO_THEME,
  GF26_LP_THEME,
]);

export const COLOR_THEMES = new Map([
  [DEFAULT_THEME, null],
  [DARK_WHITE_THEME, whiteSwooshDarkTheme],
]);
